<app-breadcrumb [title]="'Perfil'" [breadcrumb]="'Perfil'"></app-breadcrumb>
<!-- personal deatail section start -->
<section class="contact-page register-page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h3>Datos Personales</h3>
                <form [formGroup]="usuarioForm"  class="theme-form">
                    <div class="row">
                        <div class="col-md-6">
                            <i class="fa fa-id-card"></i>&nbsp;
                            <label for="nombre">Nombre</label>
                            <input formControlName="nombre" class="form-control" id="nombre" required>
                            <span class="text-danger"
                                *ngIf="(usuarioForm.get('nombre').touched) && usuarioForm.get('nombre').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                        <div class="col-md-6">
                            <i class="fa fa-id-badge"></i>&nbsp;
                            <label for="apellidoPaterno">Apellido Paterno</label>
                            <input formControlName="apellidoPaterno" class="form-control" id="apellidoPaterno" required>
                            <span class="text-danger"
                                *ngIf="(usuarioForm.get('apellidoPaterno').touched) && usuarioForm.get('apellidoPaterno').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                        <div class="col-md-6">
                            <i class="fa fa-id-badge"></i>&nbsp;
                            <label for="apellidoMaterno">Apellido Materno</label>
                            <input formControlName="apellidoMaterno" class="form-control" id="apellidoMaterno" required>
                            <span class="text-danger"
                                *ngIf="(usuarioForm.get('apellidoMaterno').touched) && usuarioForm.get('apellidoMaterno').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                       <!-- <div class="col-md-6">
                            <i class="fa fa-id-badge"></i>&nbsp;
                            <label for="fechaNacimiento">Fecha de nacimiento</label>
                            <dx-date-box class="form-control" [(value)]="fechaNacimiento" [min]="min"
                                 type="date" [max]="max"> </dx-date-box>
                            <span class="text-danger"
                                *ngIf="(usuarioForm.get('fechaNacimiento').touched) && usuarioForm.get('fechaNacimiento').errors?.required">
                                Campo requerido
                            </span>
    
                        </div>-->
                    </div>
                    <button class="btn btn-solid"  id="guardarBoton" (click)="actualizarUsuario()" >
                        <span>{{ "Guardar"}}</span>
                    </button>&nbsp;
                    <button class="btn btn-solid-regresar"  id="guardarBoton" (click)="regresar()" >
                        <span>{{ "Regresar"}}</span>
                    </button>&nbsp;<br>
                    <br>
                </form>
                &nbsp;<br>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->
<!-- address section start -->
<!--<section class="contact-page register-page section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h3>SHIPPING ADDRESS</h3>
                <form class="theme-form">
                    <div class="row">
                        <div class="col-md-6">
                            <label for="name">flat / plot</label>
                            <input type="text" class="form-control" id="home-ploat" placeholder="company name" required="">
                        </div>
                        <div class="col-md-6">
                            <label for="name">Address *</label>
                            <input type="text" class="form-control" id="address-two" placeholder="Address" required="">
                        </div>
                        <div class="col-md-6">
                            <label for="email">Zip Code *</label>
                            <input type="text" class="form-control" id="zip-code" placeholder="zip-code" required="">
                        </div>
                        <div class="col-md-6 select_input">
                            <label for="review">Country *</label>
                            <select class="form-control" size="1">
                                <option value="India">India</option>
                                <option value="UAE">UAE</option>
                                <option value="U.K">U.K</option>
                                <option value="US">US</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="review">City *</label>
                            <input type="text" class="form-control" id="city" placeholder="City" required="">
                        </div>
                        <div class="col-md-6">
                            <label for="review">Region/State *</label>
                            <input type="text" class="form-control" id="region-state" placeholder="Region/state" required="">
                        </div>
                        <div class="col-md-12">
                            <button class="btn btn-sm btn-solid" type="submit">Save setting</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>-->
<!-- Section ends -->